export default "__VITE_ASSET__DVDfCY0l__"